export default "__VITE_ASSET__CMmpXZXG__"